/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Progress, Skeleton, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import informationButton from "../../../assets/information-button.svg";
import { simpleKFormatterOnly } from "../../../redux/constants";

const AggregateSentimentCard = ({
  data,
  datatype,
  filter,
  description,
  id,
  isdownload,
  splitcolumncount,
}) => {
  const [size, setSize] = useState(1340);

  const [graphUpdate, setgraphUpdate] = useState({
    selected_chart: "verticalbar",
    widgetId: null,
  });
  const updatedGraphData = useSelector(
    (state) => state.Widget.updatedGraphData
  );
  useEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth]);
    };
    window.addEventListener("resize", updateSize);
    // updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  useEffect(() => {
    let type = `aggregate_${id}`;
    if (updatedGraphData[type]) {
      setgraphUpdate({
        selected_chart: updatedGraphData[type]?.selected_chart,
        widgetId: updatedGraphData[type]?.widgetId,
      });
    }
  }, [updatedGraphData]);

  return (
    <>
      <div
        className={`portlet_New mr-15 ${
          isdownload === true && splitcolumncount === 3 ? "mb-10" : "mb-15"
        }`}
        style={{ height: "calc(100% - 1.5rem)" }}
      >
        {!data ? (
          <Skeleton active paragraph={{ rows: 3 }} />
        ) : (
          <>
            <div
              className={`"portlet__title font-size14 font-weight500 ${
                isdownload === true && splitcolumncount === 3 ? "mb-10" : "mb-3"
              }"`}
            >
              {data?.title}
            </div>
            {graphUpdate?.selected_chart === "verticalbar" ? (
              <>
                {/* Positive */}
                <div className="row mb-2">
                  <div className="d-flex align-items-center portlet__title font-size14 col-6">
                    Positive
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-tems-center justify-content-end">
                      <div className="ml-1 portlet__content">
                        {datatype === "list" || filter > 0 ? (
                          <>
                            {" "}
                            <Tooltip
                              title={`${data?.count?.specific?.Positive?.toLocaleString()} / ${data?.count?.total?.Positive?.toLocaleString()}`}
                            >
                              <span className="font-size18 font-weight600 mr-1">
                                {simpleKFormatterOnly(
                                  data?.count?.specific?.Positive
                                )}
                              </span>
                              <span className="text-gray">
                                /
                                {simpleKFormatterOnly(
                                  data?.count?.total?.Positive
                                )}
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          <Tooltip
                            title={data?.count?.Positive?.toLocaleString()}
                          >
                            <span className="font-size18 font-weight600 mr-1">
                              {simpleKFormatterOnly(data?.count?.Positive)}
                            </span>
                          </Tooltip>
                        )}
                        {/* <span className="text-gray">({datatype === "list" || filter > 0? data?.count.percentage.Positive :data?.percentage.Positive}%)</span> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <Progress
                      trailColor="#E8EAEE"
                      success={
                        (datatype === "list" || filter > 0) && {
                          percent:
                            (data?.count?.percentage?.specific?.Positive /
                              data?.count?.percentage?.total?.Positive) *
                            100,
                          strokeColor: data?.color?.specific?.Positive,
                        }
                      }
                      percent={
                        datatype === "list" || filter > 0
                          ? 100
                          : data?.percentage?.Positive
                      }
                      showInfo={false}
                      strokeColor={
                        datatype === "list" || filter > 0
                          ? data?.color?.total?.Positive
                          : data?.color?.Positive
                      }
                    />
                  </div>
                </div>
                {/* Negative	 */}
                <div className="row mb-2">
                  <div className="d-flex align-items-center portlet__title font-size14 col-6">
                    Negative
                  </div>

                  <div className="col-6">
                    <div className="d-flex align-items-center justify-content-end">
                      <div className="ml-1 portlet__content">
                        {datatype === "list" || filter > 0 ? (
                          <>
                            <Tooltip
                              title={`${data?.count?.specific?.Negative?.toLocaleString()} / ${data?.count?.total?.Negative?.toLocaleString()}`}
                            >
                              <span className="font-size18 font-weight600 mr-1">
                                {simpleKFormatterOnly(
                                  data?.count?.specific?.Negative
                                )}
                              </span>
                              <span className="text-gray">
                                /
                                {simpleKFormatterOnly(
                                  data?.count?.total?.Negative
                                )}
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          <Tooltip
                            title={data?.count?.Negative?.toLocaleString()}
                          >
                            <span className="font-size18 font-weight600 mr-1">
                              {simpleKFormatterOnly(data?.count?.Negative)}
                            </span>
                          </Tooltip>
                        )}
                        {/* <span className="text-gray">({datatype === "list" || filter > 0? data?.count.percentage.Negative :data?.percentage.Negative}%)</span> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <Progress
                      trailColor="#E8EAEE"
                      success={
                        (datatype === "list" || filter > 0) && {
                          percent:
                            (data?.count?.percentage?.specific?.Negative /
                              data?.count?.percentage?.total?.Negative) *
                            100,
                          strokeColor: data?.color?.specific?.Negative,
                        }
                      }
                      percent={
                        datatype === "list" || filter > 0
                          ? 100
                          : data?.percentage?.Negative
                      }
                      showInfo={false}
                      strokeColor={
                        datatype === "list" || filter > 0
                          ? data?.color?.total?.Negative
                          : data?.color?.Negative
                      }
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="portlet__title d-flex align-items-center font-size14 col-6">
                    Neutral
                  </div>

                  <div className="col-6">
                    <div className="ml-1 portlet__content text-right">
                      {datatype === "list" || filter > 0 ? (
                        <>
                          <Tooltip
                            title={`${data?.count?.specific?.Neutral?.toLocaleString()} / ${data?.count?.total?.Neutral?.toLocaleString()}`}
                          >
                            <span className="font-size18 font-weight600 mr-1">
                              {simpleKFormatterOnly(
                                data?.count?.specific?.Neutral
                              )}
                            </span>
                            <span className="text-gray">
                              /
                              {simpleKFormatterOnly(
                                data?.count?.total?.Neutral
                              )}
                            </span>
                          </Tooltip>
                        </>
                      ) : (
                        <Tooltip title={data?.count?.Neutral?.toLocaleString()}>
                          <span className="font-size18 font-weight600 mr-1">
                            {simpleKFormatterOnly(data?.count?.Neutral)}
                          </span>
                        </Tooltip>
                      )}
                      {/* <span className="text-gray">({datatype === "list" || filter > 0? data?.count.percentage.Neutral :data?.percentage.Neutral}%)</span> */}
                    </div>
                  </div>

                  <div className="col-12">
                    <Progress
                      trailColor="#E8EAEE"
                      success={
                        (datatype === "list" || filter > 0) && {
                          percent:
                            (data?.count?.percentage?.specific?.Neutral /
                              data?.count?.percentage?.total?.Neutral) *
                            100,
                          strokeColor: data?.color?.specific?.Neutral,
                        }
                      }
                      percent={
                        datatype === "list" || filter > 0
                          ? 100
                          : data?.percentage?.Neutral
                      }
                      showInfo={false}
                      strokeColor={
                        datatype === "list" || filter > 0
                          ? data?.color?.total?.Neutral
                          : data?.color?.Neutral
                      }
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="mt-15">
                <table className="table border-0">
                  <thead>
                    <tr>
                      <th>
                        <sapn className="text_heading">Positive</sapn>
                      </th>
                      <th>
                        <sapn className="text_heading">Negative</sapn>
                      </th>
                      <th>
                        <sapn className="text_heading">Neutral</sapn>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {datatype === "list" || filter > 0 ? (
                          <>
                            <Tooltip
                              title={`${data?.count?.specific?.Positive?.toLocaleString()} / ${data?.count?.total?.Positive?.toLocaleString()}`}
                            >
                              <span className="font-size16 text_regular font-weight500">
                                {simpleKFormatterOnly(
                                  data?.count?.specific?.Positive
                                )}
                              </span>
                              <span className="text-gray">
                                /
                                {simpleKFormatterOnly(
                                  data?.count?.total?.Positive
                                )}
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          <Tooltip
                            title={data?.count?.Positive?.toLocaleString()}
                          >
                            <span className="font-size16 text_regular font-weight500">
                              {simpleKFormatterOnly(data?.count?.Positive)}
                            </span>
                          </Tooltip>
                        )}
                      </td>
                      <td>
                        {datatype === "list" || filter > 0 ? (
                          <>
                            <Tooltip
                              title={`${data?.count?.specific?.Negative?.toLocaleString()} / ${data?.count?.total?.Negative?.toLocaleString()}`}
                            >
                              <span className="font-size16 text_regular font-weight500 mr-1">
                                {simpleKFormatterOnly(
                                  data?.count?.specific?.Negative
                                )}
                              </span>
                              <span className="text-gray">
                                /
                                {simpleKFormatterOnly(
                                  data?.count?.total?.Negative
                                )}
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          <Tooltip
                            title={data?.count?.Negative?.toLocaleString()}
                          >
                            <span className="font-size16 text_regular font-weight500 mr-1">
                              {simpleKFormatterOnly(data?.count?.Negative)}
                            </span>
                          </Tooltip>
                        )}
                      </td>
                      <td>
                        {datatype === "list" || filter > 0 ? (
                          <>
                            <Tooltip
                              title={`${data?.count?.specific?.Neutral?.toLocaleString()} / ${data?.count?.total?.Neutral?.toLocaleString()}`}
                            >
                              <span className="font-size16 text_regular font-weight500 mr-1">
                                {simpleKFormatterOnly(
                                  data?.count?.specific?.Neutral
                                )}
                              </span>
                              <span className="text-gray">
                                /
                                {simpleKFormatterOnly(
                                  data?.count?.total?.Neutral
                                )}
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          <Tooltip
                            title={data?.count?.Neutral?.toLocaleString()}
                          >
                            <span className="font-size16 text_regular font-weight500 mr-1">
                              {simpleKFormatterOnly(data?.count?.Neutral)}
                            </span>
                          </Tooltip>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            <div
              className={`align-items-start justify-content-start mt-2 ${
                description === undefined || null ? "d-none" : "d-flex"
              }`}
            >
              <img
                src={informationButton}
                alt="information Button"
                className="mr-1"
              />
              <div className="graph-description">
                {description && description[0] && (
                  <div
                    className="mb-1"
                    dangerouslySetInnerHTML={{ __html: description[0] }}
                  />
                )}
                {description && description[1] && (
                  <div dangerouslySetInnerHTML={{ __html: description[1] }} />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AggregateSentimentCard;
